export const EXPERTISES = {
  AUDIOVISUAL: 'FILTERS_EXPERTISES_AUDIOVISUAL',
  BANK_INSURANCE: 'FILTERS_EXPERTISES_BANK_INSURANCE',
  COURRIER: 'FILTERS_EXPERTISES_COURRIER',
  DIGITAL: 'FILTERS_EXPERTISES_DIGITAL',
  DIRECTION: 'FILTERS_EXPERTISES_DIRECTION',
  ENERGY: 'FILTERS_EXPERTISES_ENERGY',
  HUMAN_RESOURCES: 'FILTERS_EXPERTISES_HUMAN_RESOURCES',
  INTL: 'FILTERS_EXPERTISES_INTL',
  MOBILE: 'FILTERS_EXPERTISES_MOBILE',
  PARTNERS: 'FILTERS_EXPERTISES_PARTNERS',
  URBAN: 'FILTERS_EXPERTISES_URBAN',
};
